module.exports = __webpack_public_path__ + "statics/img/success.1fa9835e.svg";